if(!customElements.get('quick-add')) {
    class QuickAdd extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.addEventListener('click', event => {
                if(event.target.closest('.quick-add') && event.target.closest('.quick-add').dataset.enabledDialog === 'true') {
                    const customEvent = new CustomEvent("fitBuyDialog", {
                        detail: { productHandle: event.target.closest('.quick-add').dataset.productHandle, mode: 'direct' }
                    });
                    document.dispatchEvent(customEvent);
                } else {
                    event.target.closest('.quick-add') && this.addedToCart(event.target.closest('.quick-add'),event.target.closest('.quick-add').dataset.variantId, 1);
                }               
            })
        }
        async addedToCart(target, variantId, quantity) {
            target.classList.add('active');
            const cartEndpoint = '/cart/add.js';
            const data = {
                items: [
                    {
                        id: variantId,
                        quantity: quantity
                    }
                ]
            };

            try {
                const response = await fetch(cartEndpoint, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    body: JSON.stringify(data)
                });

                if (response.ok) {
                    target.classList.remove('active');
                    const cartDrawer = document.querySelector('.Header__Icon[href="/cart"]');
                    cartDrawer && cartDrawer.click();
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({
                        event: 'quick_add_collection_click',
                        event_category: 'Collection Page',
                        event_label: target.dataset.productName,
                        product_id: target.dataset.productId
                    });
                } else {
                    console.error('Failed to add item to cart:', response.statusText);
                }
            } catch (error) {
                console.error('Error adding item to cart:', error);
            }
        }
    }
    customElements.define('quick-add', QuickAdd);
}